import { render, staticRenderFns } from "./APMA.vue?vue&type=template&id=be4c058c&"
import script from "./APMA.vue?vue&type=script&lang=js&"
export * from "./APMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports